// Branded card icons, keyed by Applications.Key. Apps without an entry fall
// back to the Bootstrap-Icons glyph named by the catalog's IconName column.
import dwrApp from "@/assets/app-icons/dwr-app.png";
import identityAdmin from "@/assets/app-icons/identity-admin.png";
import patentwatcher from "@/assets/app-icons/patentwatcher.png";
import portal from "@/assets/app-icons/portal.png";
import ttsDocReview from "@/assets/app-icons/tts-doc-review.png";
import ttsPartDisposition from "@/assets/app-icons/tts-part-disposition.png";

const brandedIcons: Record<string, string> = {
  "dwr-app": dwrApp,
  "identity-admin": identityAdmin,
  patentwatcher: patentwatcher,
  portal: portal,
  "tts-doc-review": ttsDocReview,
  "tts-part-disposition": ttsPartDisposition,
};

export function brandedIconFor(applicationKey: string): string | undefined {
  return brandedIcons[applicationKey];
}

export const portalIcon = portal;
